import { makeAutoObservable } from 'mobx';
import { zhCNStr } from '@/constants';
// import { postLogout } from '@/api/login';

const TOKEN_KEY = 'mobileToken';

const INFO_KEY = 'mobileUserInfo';

const LOCAL_INFO = localStorage.getItem(INFO_KEY);
class AppStore {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    lang = localStorage.getItem('hdcLang') || zhCNStr;

    token = localStorage.getItem(TOKEN_KEY);

    deviceInfo = {};

    proxyDrawFreeFlag = '免费';

    setDeviceInfo(obj = {}) {
        this.deviceInfo = obj;
    }

    hasPrompt = false;

    setHasPrompt(bool = true) {
        this.hasPrompt = bool;
    }

    setToken(token) {
        this.token = token;
        localStorage.setItem(TOKEN_KEY, token);
    }

    removeToken() {
        this.token = null;
        localStorage.removeItem(TOKEN_KEY);
    }

    get isLogIn() {
        return !!this.token;
    }

    userInfo = LOCAL_INFO ? JSON.parse(LOCAL_INFO) : {};

    setUserInfo(obj = {}) {
        console.log(
            'zx appStore setUserInfo, href:',
            window.location.href,
            JSON.stringify(obj)
        );
        this.userInfo = obj;
        localStorage.setItem(INFO_KEY, JSON.stringify(obj));
    }

    removeUserInfo() {
        this.userInfo = {};
        localStorage.removeItem(INFO_KEY);
    }

    setLoginData(data) {
        this.setToken(data.token);
        const NEXT_USER_INFO = data.userinfo;

        if (NEXT_USER_INFO) {
            // 企业版，如果未选择企业则自动选择
            if (NEXT_USER_INFO.type === 2 && !NEXT_USER_INFO.enterprise) {
                NEXT_USER_INFO.enterprise =
                    NEXT_USER_INFO.enterpriseSelects.find(organization => {
                        const findId =
                            organization.branchId || organization.enterpriseId;
                        return NEXT_USER_INFO.enterpriseId === findId;
                    });
            }

            this.setUserInfo(NEXT_USER_INFO);
        }
    }

    async logout() {
        /*const { code } = await postLogout();
    if (code !== 0) return Promise.reject();*/
        this.clearLoginData();
        return Promise.resolve();
    }

    clearLoginData() {
        this.removeUserInfo();
        this.removeToken();
    }

    setPDFviwer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }

    getPDFviwer() {
        return this.pdfViewer;
    }
    getUserInfo() {
        return this.userInfo;
    }

    setProxyDrawFreeFlag(flag) {
        this.proxyDrawFreeFlag = flag;
    }
}

const appStore = new AppStore();

export default appStore;
